import { gql } from "@apollo/client";

export const GET_PROFESSIONAL_APP_ACTIVITY = gql`
  query GetProfessionalAppActivity($filter: ProfessionalAppActivityFilter, $limit: Int, $offset: Int) {
    getProfessionalAppActivity(filter: $filter, limit: $limit, offset: $offset) {
      status
      message
      data {
        trackingSince
        groups {
          key
          label
        }
        features {
          key
          label
          group
          uses
          people
          errors
          lastAt
        }
        notTracked
        people {
          employeeId
          name
          status
          actions
          errors
          activeDays
          appOpens
          logins
          featuresUsed
          lastAt
          byGroup
          cashPending
          cashPendingBookings
          settleRequested
          oldestUnsettled
        }
        days {
          day
          actions
          people
        }
        total
        entries {
          id
          createdAt
          employeeId
          employeeName
          feature
          label
          group
          bookingId
          amount
          outcome
          message
          args
        }
      }
    }
  }
`;
